import React, { useEffect, useState } from 'react';
import { InitializeAnalytics } from '../../utilities/Analytics';

export function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const path = window.location.pathname.toLowerCase();
        
        // Exclude admin, overlay, and screen interfaces
        if (
            path.startsWith('/admin') || 
            path.startsWith('/screen') || 
            path.includes('overlay') || 
            path.includes('/abcdef')
        ) {
            return;
        }

        // Check if consent has already been registered
        const consent = localStorage.getItem('cookie_consent');
        if (consent === 'true') {
            InitializeAnalytics();
        } else if (consent === null) {
            // Show banner if no selection has been made
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'true');
        InitializeAnalytics();
        setIsVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem('cookie_consent', 'false');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div 
            className="CookieBanner position-fixed bottom-0 start-50 translate-middle-x w-100 p-3" 
            style={{ 
                zIndex: 10000, 
                maxWidth: '600px',
                fontFamily: '"Montserrat", "Inter", sans-serif'
            }}
        >
            <div 
                className="card shadow-lg border-0 p-3 text-white bg-dark bg-opacity-95 rounded-4 border-top border-danger"
                style={{ 
                    backdropFilter: 'blur(8px)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
                }}
            >
                <div className="d-flex flex-column gap-2 text-center text-md-start">
                    {/* <h5 className="mb-1 fw-bold text-danger" style={{ fontSize: '1rem' }}>
                        🍪 Consentimiento de Cookies
                    </h5> */}
                    <p className="mb-0 text-white-50 small" style={{ lineHeight: '1.4' }}>
                        {/* Usamos cookies para mejorar tu experiencia de juego y analizar el tráfico a través de Google Analytics 4 y GTM. ¿Aceptas el uso de cookies? Puedes consultar nuestra Política de Cookies en cualquier momento. */}
                        Usamos cookies para mejorar tu experiencia de juego y analizar el tráfico.
                    </p>
                    <div className="d-flex justify-content-center gap-2 mt-1">
                        <button 
                            type="button" 
                            onClick={handleAccept} 
                            className="btn btn-sm btn-danger px-5 rounded-3 fw-bold"
                        >
                            Aceptar
                        </button>
                        <button 
                            type="button" 
                            onClick={handleReject} 
                            className="btn btn-sm btn-link text-light px-2 ms-4 rounded-3"
                        >
                            Rechazar
                        </button>
                    </div>
                    <p className="mb-0 mt-2 text-white-50 small text-center" style={{ lineHeight: '1.4' }}>
                        Política de Cookies
                    </p>
                </div>
            </div>
        </div>
    );
}
export default CookieBanner;
